export const WATER_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "water.bottle_sealed",
        name: "SEALED WATER BOTTLE",
        shortName: "WATER BOTTLE",
        description: "Half a litre of factory-sealed drinking water.",
        category: "WATER",
        tags: ["DRINK", "PLASTIC", "SEALED"],
        stackLimit: 6,
        unitMassGrams: 525,
        volumeMl: 580,
        longestDimensionMm: 210,
        iconKey: "bottle",
        worldAssetId: "water_bottle",
        scarcity: "COMMON",
        sortOrder: 20,
    },
    {
        id: "water.bottle_empty",
        name: "EMPTY WATER BOTTLE",
        shortName: "EMPTY BOTTLE",
        description: "A reusable plastic bottle with a sound cap.",
        category: "WATER",
        tags: ["PLASTIC"],
        stackLimit: 10,
        unitMassGrams: 25,
        volumeMl: 580,
        longestDimensionMm: 210,
        iconKey: "bottle",
        worldAssetId: "water_bottle",
        scarcity: "COMMON",
        sortOrder: 21,
    },
]);
